module.exports = __webpack_public_path__ + "img/minhasempresas.e5f0b1d0.png";